/**
 * v2 사이드네비 2단계 메뉴 펼침 상태 저장 (FIKET-428)
 *
 * 부모 항목의 `to` → 펼침 여부. 하위 경로 진입 시 SideNav 가 자동으로 true 로 바꾸고,
 * 사용자가 토글한 값도 여기 남아 새로고침 후 유지된다. font-scale.ts 와 같은 localStorage 패턴.
 */

export type NavOpenState = Record<string, boolean>

const STORAGE_KEY = 'fiket-admin:v2-nav-open'

/** 저장값 파싱 — 객체가 아니거나 손상되면 빈 상태. boolean 값만 채택 */
export function parseNavOpenState(raw: string | null | undefined): NavOpenState {
  if (!raw) return {}
  try {
    const parsed: unknown = JSON.parse(raw)
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return {}
    const out: NavOpenState = {}
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof v === 'boolean') out[k] = v
    }
    return out
  } catch {
    return {}
  }
}

/** localStorage 저장값 로드 (접근 불가·없음·손상 시 빈 상태) */
export function loadNavOpenState(): NavOpenState {
  try {
    return parseNavOpenState(window.localStorage.getItem(STORAGE_KEY))
  } catch {
    return {}
  }
}

export function saveNavOpenState(state: NavOpenState) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {
    // 프라이빗 모드 등 저장 실패는 무시 — 세션 내 상태는 유지
  }
}
